var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('closed-card',{staticClass:"account-investigation-closed-card",class:_vm.cardType,attrs:{"title":_vm.formattedAccount,"sub-title":_vm.cardSubtitle}})}
var staticRenderFns = []

export { render, staticRenderFns }